import { render, staticRenderFns } from "./AddTemplateService.vue?vue&type=template&id=c64d5864&scoped=true&"
import script from "./AddTemplateService.vue?vue&type=script&lang=js&"
export * from "./AddTemplateService.vue?vue&type=script&lang=js&"
import style0 from "./AddTemplateService.vue?vue&type=style&index=0&id=c64d5864&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c64d5864",
  null
  
)

export default component.exports